const pauseMenu: HTMLElement | null = document.getElementById("pausemenu");
const mapOverlay: HTMLElement | null = document.getElementById("mapOverlay");
const closeBTN: HTMLElement | null = document.getElementById("closeBTN");

let isActive: boolean = false;
let isMapActive: boolean = false;

export function toggleMapOverlay(): void {
    console.log(isMapActive);
    if (isMapActive) {
        mapOverlay?.classList.remove("active");
        isMapActive = false;
    }
    else {
        mapOverlay?.classList.add("active");
        isMapActive = true;
    }
}

if (closeBTN) {
    closeBTN.addEventListener("click", () => {
        console.log("close was clicked");
        toggleMapOverlay();
    });
}

document.addEventListener("keydown", (event: KeyboardEvent) => {
    console.log(`The key ${event.key} was pressed`);

    if (event.key === "Escape" && pauseMenu) {
        if (isActive) {
            pauseMenu.classList.remove("active");
            isActive = false;
        }
        else {
            pauseMenu.classList.add("active");
            isActive = true;
        }
    }
});
